import questionTypes from '../questionTypes';
import formatValidationTypeList from '../formatValidationTypeList';
import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.respondentInfoShortText,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    remaining: true,
    labelEnabled: true,
    label: 'Input label',
    formatValidationType: formatValidationTypeList.none,
    maximumCharacters: 100,
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
};
